import React from 'react';
import './App.css';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import Navbar from './components/Navbar';
import Home from './components/pages/Home'
import Team5 from './components/pages/Team5';
import Prototype from './components/pages/Prototype';
import SignUp from './components/pages/SignUp';

function App() {
  return (
    <>
     <Router>
      <Navbar />
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/team5' component={Team5} />
        <Route path='/prototype' component={Prototype} />
        <Route path='/sign-up' component={SignUp} />
      </Switch>
      </Router>
      </>

  );
}

export default App;
